import { EntryStatus } from 'chaika-frontend-types/frontend-cms';

export enum MobileFieldsOfLane {
    SingleField = 'singleField',
    PairField = 'pairField',
}

export enum MobileFieldTypes {
    Button = 'button',
    Text = 'text',
    Phone = 'phone',
    StatusIcon = 'statusIcon',
    Line = 'line',
    Indicator = 'indicator',
    Link = 'link',
    Time = 'time',
    DateField = 'date',
    Agreement = 'agreement',
}

export interface MobileCardData {
    id?: string;
    recordId?: string | number;
    status?: EntryStatus;
    isSignedWithEDS?: boolean;
    visitTime?: string;
    futurePatient?: boolean;
    link?: string;
}

export interface MobileField<D extends MobileCardData = MobileCardData> {
    title: string;
    accessor: Extract<keyof D, string>;
    hide?: boolean;
    hideIfEmpty?: boolean;
    fieldsOnLane?: MobileFieldsOfLane;
    isPrimary?: boolean;
    withoutTitle?: boolean;
    fieldType: MobileFieldTypes;
}
